<template>
  <div class="nav">
    <div :class="control==true ? 'm_top_w' : 'm_top'">
      <div class="wrap">
        <div class="logo">
          <img :src="control==true ? logoUrl1 : logoUrl"
               :class="control==true ? 'imgLogo1' : 'imgLogo'"  />
          <span v-if="control"
                style="background: #FFFFFF;width: 3px;height: 48px;margin-left: 20px;margin-top: 8px;"></span>
          <div v-if="control" style="font-size: 18px;margin: 0;padding: 0;margin-top: 8px;letter-spacing: 1px;text-align: left;">
            <div style="font-size: 18px;height: 30px;line-height: 30px;margin-left: 10px;">货代行业</div>
            <div style="font-size: 18px;height: 30px;line-height: 30px;margin-left: 10px;">招聘最直接的平台</div>
          </div>
        </div>
        <ul class="m_menu">
          <li v-show="!hideMenu">
            <span :class="currentIndex == 0 ? 'on':''" @click="handleInvite">
              <a hidefocus="true" class="active">
                <!--展会 ———— 招聘会 -->
                <em>{{language.jobFair}}</em>
              </a>
            </span>
          </li>

          <li v-show="!hideMenu">
            <span :class="currentIndex == 1 ? 'on':''" @click="handleToken">
              <a hidefocus="true"  class="active">
                <!--账户管理 ———— 个人中心 -->
                <em>{{language.personalCenter}}</em>
              </a>
            </span>
          </li>
          <li v-show="!hideMenu" v-if="lan2=='ch'">
            <span :class="currentIndex == 2 ? 'on':''">
              <a style="margin: 0 20px;">
                <el-popover
                  :offset="-20"
                  placement="bottom-start"
                  trigger="click"
                  :visible-arrow="false"
                >
                  <img
                    src="../../assets/img/28.jpg"
                    style="width: 130px;height: 130px;padding: 20px;"
                  />
                  <div slot="reference" style="font-size: 16px">{{language.applet}}</div>
                </el-popover>
              </a>
            </span>
          </li>

          <li v-show="!hideMenu" v-if="token == null || token == undefined">
            <span :class="currentIndex == 3 ? 'on':''">
              <a hidefocus="true" href="login.html" class="active">
                <em>{{language.login}}</em>
              </a>
            </span>
          </li>

          <li v-show="!hideMenu" v-if="token != null">
            <span :class="currentIndex == 3 ? 'on' : ''">
              <a style="margin: 0 20px;">
                <el-popover
                  placement="bottom-start"
                  width="120"
                  :offset="-20"
                  trigger="click"
                  :visible-arrow="false"
                >
                  <a hidefocus="true" @click="handleLogout" class="active">
                    <el-button type="text" icon="el-icon-switch-button">{{language.logout}}</el-button>
                  </a>
                  <div slot="reference" style="font-size: 16px">
                    {{lan2=="ch"?(userInfo.true_name||userInfo.true_name_en):(userInfo.true_name_en||userInfo.true_name)}}
                    <i class="el-icon-arrow-down el-icon&#45;&#45;right" style="margin-left: 10px"></i>
                  </div>
                </el-popover>
              </a>
            </span>
          </li>

          <li v-show="!hideMenu" v-if="token == null">
            <span :class="currentIndex == 4 ? 'on':''">
              <a hidefocus="true" href="register.html" class="active">
                <em>{{language.register}}</em>
              </a>
            </span>
          </li>

<!--          <li>-->
<!--            <span @click="handledSwitchLanguage">-->
<!--              <a class="active">-->
<!--                <em>{{language.english}}</em>-->
<!--              </a>-->
<!--            </span>-->
<!--          </li>-->
          <li v-if="lan2=='ch'">
            <span :class="currentIndex == 6 ? 'on':''" @click="handleUsage">
              <a hidefocus="true"  class="active">
                <em>{{language.HTC}}</em>
              </a>
            </span>
          </li>
          <li v-else>
            <span :class="currentIndex == 6 ? 'on':''">
              <a hidefocus="true" href="usagesen.html" class="active">
                <em>{{language.HTC}}</em>
              </a>
            </span>
          </li>



          <!--<li v-show="!hideMenu">
            <span :class="currentIndex == 7 ? 'on':''">
              <a hidefocus="true" href="performs.html" class="active">
                <em>{{language.perform}}</em>
              </a>
            </span>
          </li>-->
          <!--<li>
            <span :class="currentIndex == 7 ? 'on':''">
              <a hidefocus="true" href="beian.html?exhibition_id=2" class="active">
                <em>{{language.HTC}}</em>
              </a>
            </span>
          </li>-->

        </ul>
      </div>
    </div>
    <!-- <el-dialog
      :title="language.hint"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      top="40vh"
      style="z-index:9999 !important;">
      <div style="z-index:9999 !important;font-size:16px;text-align:center;">
        <span>您被{{datacount.broadcast_name}}的直播间叫号，是否进入</span>
      </div>
      <div class="datacount-formBtn">
        <el-button  class="datacount-down-formBtn" @click="dialogVisible = false">取 消</el-button>
        <el-button class="datacount-camcale-formBtn" type="primary" @click="golive();dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import Cook from "../../common/cookie";
import { language } from "../../language/get";
import store from "../../store";
import { mapGetters } from "vuex";

import { isCall } from "../../api/exhibition";

import { stateEnum } from "../../pages/forum/oneToOne/enum";
import { roomUrl, videoUrl, windowsGoTo } from "../../common/url";
import { getBroadcastList, getLiveUrl, getNewLiveUrl,liverRoomBuy } from "../../api/forum";
import {MessageBox} from "element-ui";

export default {
  props: {
    currentIndex: {
      type: Number,
      default: 0
    },
    control: {
      type:Boolean,
      dafault:false
    },
    hideMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lan2: 'ch',
      language: language(),
      // logoUrl: require('@/assets/top-logo-index-cn.png'),
      // logoUrl: require('@/assets/logo.png')
      logoUrl: require('@/assets/img/39.png'),
      logoUrl1: require('@/assets/img/logo-bai.png'),

      stateEnum,
      datacount:{},
      dialogVisible: false,
    };
  },
  mounted() {
    let lan = Cook.get("lang");
    if (lan == "ch") {
    } else {
      this.logoUrl = require('@/assets/logonew_en.png');
      // this.logoUrl = require('@/assets/logo_en.png');
    }
    this.lan2 =lan;
    // console.log(this.lan2);
    // this.getIsCall()
    // setInterval(()=>{
    //   this.getIsCall()
    // }, 3000)
  },
  methods: {

    getIsCall(){
      if(this.$store.state.user.token){
        let params = {
          token: this.$store.state.user.token,
        }

        isCall(params).then(res => {
          console.log(res);
          if(res.type == '1'){
            this.datacount = res.datacount;
            this.dialogVisible = true;
          }
          // else {
          //   if (this.lan == "ch") {
          //     return this.$message.error({ message: res.text, offset: 120 });
          //   }
          //   return this.$message.error({ message: res.text_en, offset: 120 });
          // }
        });
      }
    },



    //新进入直播间
    golive(){
        let _this = this;
        // if (
        //     this.token == null ||
        //     this.token == undefined ||
        //     this.exhibitionId == null
        // ) {
        //     this.loginData = { exhibitionId: this.datacount.exhibitionId };
        //     this.handleToken();
        //     return;
        // }
        // if (!isInternet() && this.datacount.state == this.stateEnum.JOIN_DISCUSS) {
        //     return (this.downloadShow = true);
        // }
        this.broadcastId = this.datacount.broadcast_id;

        //获取是否可以无票进入直播间
        liverRoomBuy({}).then(res => {
            // console.log(res);
            // return;
            if(res == 0){
                const props = {
                    token: this.token,
                    broadcast_id: this.datacount.broadcast_id
                };
                //进入直播间
                this.$store
                    .dispatch("getLiveInfo", props)
                    .then(res => {
                        if (res.type != "1") {
                            if (res.type == "e1") {
                                this.$message.error({
                                    message: this.lan == "ch" ? res.text : res.text_en,
                                    offset: 135
                                });
                                setTimeout(function() {
                                    return (window.location.href = ticketsRegisterUrl(
                                        4,
                                        this.datacount.exhibition_id
                                    ));
                                }, 2000);
                            }
                            if (isEmpty(res.data)) {
                                if (this.lan == "ch") {
                                    return this.$message.error({
                                        message: res.text,
                                        offset: 120
                                    });
                                } else {
                                    this.$message.error({ message: res.text_en, offset: 120 });
                                }
                                return;
                            }
                            const data = res.data[0];
                            if (data.type != 1) {
                                if (this.lan == "ch") {
                                    return this.$message.error({
                                        message: res.text,
                                        offset: 120
                                    });
                                } else {
                                    this.$message.error({ message: res.text_en, offset: 120 });
                                }
                                return;
                            }
                            const waitData = {
                                token: this.token,
                                roomid: data.roomid
                            };
                            //需要排队
                            if (res.data[0].type == 1) {
                                this.waitData = waitData;
                                this.visibleLine = true;
                            }
                            return;
                        }
                        const data = res.data[0];
                        let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
                        return (window.location.href = windowsGoTo() + roomUrl(data, name));
                        // return (window.open(windowsGoTo() + roomUrl(data, this.userInfo.true_name)));
                        const goData = {
                            token: this.token,
                            roomid: data.roomid
                        };
                    })
                    .catch(() => {});

            }else{
                const props = {
                    token: this.token,
                    broadcast_id: this.datacount.broadcast_id
                };
                //进入直播间
                this.$store
                    .dispatch("getNewLiveUrl", props)
                    .then(res => {
                        if (res.type != "1") {
                            if (isEmpty(res.data)) {
                                if (this.lan == "ch") {
                                    return this.$message.error({
                                        message: res.text,
                                        offset: 120
                                    });
                                } else {
                                    this.$message.error({ message: res.text_en, offset: 120 });
                                }
                                return;
                            }
                            const data = res.data[0];
                            if (data.type != 1) {
                                if (this.lan == "ch") {
                                    return this.$message.error({
                                        message: res.text,
                                        offset: 120
                                    });
                                } else {
                                    this.$message.error({ message: res.text_en, offset: 120 });
                                }
                                return;
                            }
                            const waitData = {
                                token: this.token,
                                roomid: data.roomid
                            };
                            //需要排队
                            if (res.data[0].type == 1) {
                                this.waitData = waitData;
                                this.visibleLine = true;
                            }
                            return;
                        }
                        const data = res.data[0];
                        let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
                        return (window.location.href =
                            windowsGoTo() + roomUrl(data, name));
                        const goData = {
                            token: this.token,
                            roomid: data.roomid
                        };
                    })
                    .catch(() => {});
            }



        });

    },



    handleToken() {
      // if (
      //   this.token == undefined ||
      //   this.token == null ||
      //   Object.keys(this.userInfo).length == 0
      // ) {
      //   return (window.location.href = "login.html");
      // }

      let url = window.location.href.split("?");
      let url2 = url[0].substring(url[0].lastIndexOf("/")+1);
      // console.log("地址==" , url);
      // console.log("地址==" , url2);
      let message = "";
      if(this.userInfo.user_nature == 1) {
        message = "直播间正在面试中，如要跳转其他页面请先结束洽谈。";
      }else if(this.userInfo.user_nature == 3){
        message = "直播间正在面试中，如要跳转其他页面请先关闭直播间。";
      }
      if(url2 == "livestudio.html")
      {
        MessageBox({
          title: "",
          message: message,
          confirmButtonText: language().confirm,
          cancelButtonText: language().cancel,
          showCancelButton: false,
        }).then(() => {
          return;
          //确认
        }).catch(() => {
          //取消
        });
        return;
      }else{
        return (window.location.href = "user.html");
      }

    },
    handleInvite(){
      let url = window.location.href.split("?");
      let url2 = url[0].substring(url[0].lastIndexOf("/")+1);
      // console.log("地址==" , url);
      // console.log("地址==" , url2);
      let message = "";
      if(this.userInfo.user_nature == 1) {
        message = "直播间正在面试中，如要跳转其他页面请先结束洽谈。";
      }else if(this.userInfo.user_nature == 3){
        message = "直播间正在面试中，如要跳转其他页面请先关闭直播间。";
      }
      if(url2 == "livestudio.html")
      {
        MessageBox({
          title: "",
          message: message,
          confirmButtonText: language().confirm,
          cancelButtonText: language().cancel,
          showCancelButton: false,
        }).then(() => {
          return;
          //确认
        }).catch(() => {
          //取消
        });
        return;
      }else{
        return (window.location.href = "index.html");
      }
    },
    handleUsage() {
      let url = window.location.href.split("?");
      let url2 = url[0].substring(url[0].lastIndexOf("/")+1);
      // console.log("地址==" , url);
      // console.log("地址==" , url2);
      let message = "";
      if(this.userInfo.user_nature == 1) {
        message = "直播间正在面试中，如要跳转其他页面请先结束洽谈。";
      }else if(this.userInfo.user_nature == 3){
        message = "直播间正在面试中，如要跳转其他页面请先关闭直播间。";
      }
      if(url2 == "livestudio.html")
      {
        MessageBox({
          title: "",
          message: message,
          confirmButtonText: language().confirm,
          cancelButtonText: language().cancel,
          showCancelButton: false,
        }).then(() => {
          return;
          //确认
        }).catch(() => {
          //取消
        });
        return;
      }else{
        return (window.location.href = "usages.html");
      }
    },
    handledSwitchLanguage() {
      let lan = Cook.get("lang");
      let page ='';
      if (lan == null || lan == undefined) {
        Cook.set("lang", "ch", 7);
      }
      if (lan == "ch") {
        Cook.del("lang");
        Cook.set("lang", "en", 7);
        page ='usagesen.html';
      } else {
        Cook.del("lang");
        Cook.set("lang", "ch", 7);
        page ='usages.html';
      }
      // location.reload();

      let curUrl=window.location.href;
      if(curUrl.indexOf('usages') != -1){
        location.href = page;
        return;
      }else{
        location.reload();
      }

    },
    async handleLogout() {
      store.dispatch("Logout", { token: this.token }).then(res => {
        if (res.type == "1") {
          this.$message.success({
            message: this.language.exitSuccess,
            offset: 120,
            duration: 5000
          });
        }
        window.location = "index.html";
      });
    }
  },
  computed: {
    ...mapGetters(["userInfo", "token"])
  }
};
</script>
<style scoped>

</style>
<style>
/* .v-modal{
    z-index: 0 !important;
  } */
.el-popover {
  min-width: 120px !important;
  padding: 0 !important;
  border: none !important;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
}
</style>
<style scoped>
.nav {
  width: 100%;
  height: 81px;
  /* background-color: #0f408a; */
  min-width: 1200px;
  position: relative;
  left: 0;
  top: 0;
  z-index: 900;
}

.imgLogo{
  width:208px;
  height:37px;
  border: 0px;
}
.imgLogo1{
  width:239px;
  height:37px;
  border-right: 0px;
  margin-top: 8px;
}
/*.m_top_w .logo {*/
/*  padding-right: 15px;*/
/*  border-right: 1px solid #333333;*/
/*}*/


.m_top {
  position: relative;
  z-index: 900;
  height: 80px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
   background: #fff;
  /* box-shadow: 0 0 8px rgba(0, 0, 0, 0.1); */
  /* background: #0f408a; */
}
.m_top_w {
  position: relative;
  z-index: 900;
  height: 80px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  background: transparent;
}

.m_top .wrap,
.m_top_w .wrap{
  width: 1200px;
  margin: auto;
}

.m_top .logo,
.m_top_w .logo{
  float: left;
  height: 80px;
  font-size: 21px;
  line-height: 80px;
  color: #ffffff;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.m_top .logo span {
  font-size: 16px;
}

.wrap .logo a {
  float: left;
  width: 157px;
  height: 100%;
  color: #ffffff;
  padding-right: 20px;
  text-indent: -9999px;
}

.m_menu {
  height: 80px;
  float: right;
}
.el-dropdown-link:focus {
  outline: 0 !important;
}
.m_menu li {
  position: relative;
  background-position: right -300px;
  float: left;
  height: 80px;
  font-size: 16px;
  margin:0 10px;
}

.m_menu li span {
  background: none;
  float: left;
  height: 78px;
  line-height: 80px;
  font-size: 16px;
  color: #000000;
  text-align: center;
}
.m_top_w .m_menu li span{
  background: none;
  float: left;
  height: 78px;
  line-height: 80px;
  font-size: 16px;
  color: #FFFFFF;
  text-align: center;
}

.m_menu li a {
 /* padding:0 20px; */
  line-height: 70px;
  color: #000000;
  /* color: #fff; */
  float: left;
  height: 70px;
  font-size: 16px;
  cursor: pointer;
}
.m_top_w .m_menu li a {
  /* padding:0 20px; */
  line-height: 70px;
  color: #ffffff;
  /* color: #fff; */
  float: left;
  height: 70px;
  font-size: 16px;
  cursor: pointer;
}

.m_menu li span:hover,
.m_menu li span.on {
  color: #5493f8;
  border-bottom:2px solid #5493f8;
  font-weight: bold;

  /* color: #fff;
  background-color: #092652;
  border-bottom: 2px solid #f4a100; */
}
.m_top_w .m_menu li span:hover,
.m_top_w .m_menu li span.on {
  color: #f47900;
  border-bottom:2px solid #f47900;
  font-weight: bold;

  /* color: #fff;
  background-color: #092652;
  border-bottom: 2px solid #f4a100; */
}
.m_menu li span a:hover {
  color:#5493f8;
  /* color: #fff; */
}
.m_top_w .m_menu li span a:hover {
  color:#f47900;
  /* color: #fff; */
}

.m_menu li a em {
  float: left;
  height: 80px;
  line-height: 80px;
  font-size: 16px;
  font-style: normal;
  text-align: left;
  margin: 0 20px;
}

.m_menu li span.on a.active {
  color:#5493f8;
  /* color: #ffffff; */
}
.m_top_w .m_menu li span.on a.active {
  color:#f47900;
  /* color: #ffffff; */
}


.datacount-formBtn{
  /* text-align: right !important;
  margin-top: 20px !important;
  margin-right: 20px !important; */
  text-align: center;
  margin: 0 auto;
  margin-top: 40px;
}
.datacount-down-formBtn{
    background: #cccccc !important;
    width: 100px !important;
    height: 40px !important;
    color: #ffffff !important;
    border: none !important;
    font-size: 18px !important;
    margin-right: 30px;
}
.datacount-camcale-formBtn{
    background: #ff9e00 !important;
    width: 100px !important;
    height: 40px !important;
    color: #ffffff !important;
    border: none !important;
    font-size: 18px !important;
    margin-left: 30px;
}
</style>
